import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { applyMiddleware, createStore, combineReducers } from "redux";
import { Provider } from "react-redux";
import promise from "redux-promise";

// importando estilo
//import 'semantic-ui-css/semantic.min.css'

//importando reducers
import Reducers from "./main/reducers";

//const store = createStore(Reducers)

const devTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

const store = applyMiddleware(promise)(createStore)(Reducers, devTools);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
